import React from "react";
import styles from './map_device.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUser} from "@fortawesome/free-solid-svg-icons";

export default function MapDevice({setSelectedDevice, device}) {
    const getColor = () => {
        if(device.high_count > 0) {
            return '#F43F5E';
        } else if (device.medium_count > 0) {
            return '#F59E0B';
        } else {
            return '#22C55E';
        }
    }

    const getCount = () => {
        if(device.high_count > 0) {
            return device.high_count;
        } else if (device.medium_count > 0) {
            return device.medium_count;
        } else {
            return device.low_count;
        }
    }

    const getAlertSum = () => {
        return device.high_count + device.medium_count + device.low_count;
    }
    return (
        <div
            className={styles.container}
            onClick={() => setSelectedDevice(device)}
            style={{border: `4px solid ${getColor()}`, fontWeight: '600', fontSize: 'large'}}
        >
            {getAlertSum()}
        </div>
    );
}